import React from 'react';
import { Card, CardContent, Typography, Box, CardMedia } from '@mui/material';
import { Constants } from '../constants';
import ReadMoreText from '../utils/ReadMore';

const FaqCard = ({ index, item }) => {
  const { faq_question, faq_answer } = item
  return (
    <Card sx={{ boxShadow: "none", p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: '50px',
            fontWeight: '700',
            mt: 2,
            color: 'primary.main',
            WebkitTextStroke: '1px #DC143C',
            flexShrink: 0,
          }}
        >
          {index + 1}
        </Typography>
        <Box sx={{ flex: 1, display: 'flex' }}>
          <CardMedia
            component="img"
            src={Constants.customImages.ComputerImg}
            alt="Classroom scene"
            sx={{ borderRadius: 2, height: '200px', width: '100%', objectFit: 'cover' }}
          />
        </Box>
      </Box>



      <CardContent>
        <Typography sx={{
          mt: 2,
          fontSize: "50px",
          fontWeight: "700",
          lineHeight: "30px",
          color: "#D0D0D0",
          display: "flex",
          textAlign: "start"
        }}>“</Typography>
       <ReadMoreText text={faq_answer} />
       <Typography variant="h6" fontSize={"20px"} fontWeight={500} sx={{ mt: 2, textAlign: "center" }}>
          {faq_question}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default FaqCard;
